<template>
  <RoleMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
